import { useEffect, useState } from 'react';
import { URL_BACKEND } from '../controllers/config';
import { GetToken } from '../components/util/Helpers/Auth';

interface IUseFetch {
  url: string;
  options?: {};
  params?: {};
  deps?: any[];
}

export const useFetch = ({ url, options, params, deps }: IUseFetch) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>();
  const [error, setError] = useState<unknown>();
  const [status, setStatus] = useState<number>();

  const fetchUrl = new URL(`${URL_BACKEND}/${url}`);
  fetchUrl.search = new URLSearchParams(params).toString();

  const fetchOptions = {
    ...options,
    headers: {
      'User-Token': GetToken()
    }
  };

  useEffect(
    () => {
      const fetchData = async () => {
        setLoading(true);

        try {
          setLoading(false);
          const res = await fetch(fetchUrl.toString(), fetchOptions);
          const status = res.status;
          const json = await res.json();

          setData(json);
          setStatus(status);
        } catch (e) {
          setError(e);
        }
      };

      fetchData();
    },
    deps ? deps : []
  );

  return { loading, data, error, status };
};
